export enum GanttLinks {
    EndStart = 1,
    StartStart,
    EndEnd,
    StartEnd,
}
